import React from "react";
import { withNamespaces } from "react-i18next";
import { Card, CardBody, CardTitle, Col, Table } from "reactstrap";
import DateUtils from "src/services/utils/DateUtils";
import { EMPTY_LIST, INTERNATIONAL_DATE_TIME_FORMAT } from "src/common/constants";
import { KYBCreditTypes } from "src/modules/3rd-party-management/constants";

const CreditTransactions = ({ t, transactions = [] }) => {
    const dateUtils = new DateUtils();
    const rows = Array.isArray(transactions) ? transactions : [];

    return (
        <Col sm="12" md="12">
            <Card>
                <CardBody>
                    <CardTitle tag="h4">
                        {t("{{creditLabel}} Transactions", {
                            creditLabel: "Credit",
                        })}
                    </CardTitle>
                    <Table responsive bordered>
                        <thead>
                            <tr>
                                <th>{t("Transaction ID")}</th>
                                <th>Credit</th>
                                <th>{t("Type")}</th>
                                <th>{t("Note")}</th>
                                <th>{t("Creation Date")}</th>
                                <th>{t("Renewal Date")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.length > 0 ? (
                                rows.map((tx) => (
                                    <tr key={tx.id}>
                                        <td>{tx.id}</td>
                                        <td>{tx.licenseCount.toLocaleString()}</td>
                                        <td>{t(KYBCreditTypes[tx.data_type]?.title)}</td>
                                        <td title={tx.note}>{tx.note}</td>
                                        <td>
                                            {dateUtils.convertDateToDate(
                                                tx.createdAt,
                                                INTERNATIONAL_DATE_TIME_FORMAT
                                            )}
                                        </td>
                                        <td>
                                            {tx.renewalDate
                                                ? dateUtils.convertDateToDate(
                                                      tx.renewalDate,
                                                      INTERNATIONAL_DATE_TIME_FORMAT
                                                  )
                                                : "-"}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" className="text-center">
                                        {t(EMPTY_LIST)}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                   
                    </Table>
                </CardBody>
            </Card>
        </Col>
    );
};

export default withNamespaces()(CreditTransactions);
